// extracted by mini-css-extract-plugin
export default {"visible":"border-icons-module-be21fcd2956f217eb184","hidden":"border-icons-module-aee1ed232065ea18caf6"};